export const blockIconsUiactionsBoltNew = (
	<span className='material-symbols-outlined'>bolt</span>
);
